const StreetType = Object.freeze({
  6: 'CL',
  3: 'AV',
});

const StreetTypeOptions = Object.freeze([
  { 6: 'CL' },
  { 3: 'AV' },
]);
export { StreetType, StreetTypeOptions };
